import React, { useEffect, useState } from 'react';
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import TableComponent from '../../../components/DataTable/TableComponent';
import Pagination from '../../../components/Pagination/Pagination';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { dateIntoYYYY_MM_DD } from '../../../utils/dateTimeConverter';

const AdSetTab = ({ date, selectedCampaign, setSelectedAdSet, setSelectedTab, selectedAdSet, selectedMetaAccount }) => {
    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });

    async function getList() {
        loadingShow();
        let postData = {
            metaAdsAccountId: selectedMetaAccount?.metaAdsAccountId
        }
        if (date?.startDate) {
            postData.startDate = dateIntoYYYY_MM_DD(date.startDate);
            postData.endDate = dateIntoYYYY_MM_DD(date.endDate);
        }
        let url = `${urlApi.getMetaAdsSetList}?page=${activePage}&limit=${perPage}`;
        if (selectedCampaign) {
            url += `&campaignId=${selectedCampaign?._id}`;
        }
        let resp = await postApi(postData, url);
        loadingHide();
        if (resp.responseCode === 200) {
            let localData = selectedAdSet ? resp?.data?.items?.map((item) => {
                if (selectedAdSet?._id === item?._id) {
                    const isSelected = !item.toggleSelected;
                    return {
                        ...item,
                        toggleSelected: isSelected,
                    };
                }
                return {
                    ...item,
                    toggleSelected: false,
                };
            }) : resp?.data?.items
            setTableData({
                data: localData,
                totalCount: resp.data.count
            });
        } else {
            setTableData({
                data: [],
                totalCount: 0
            });
        }
    }

    useEffect(() => {
        getList();
    }, [activePage, date, selectedCampaign, selectedMetaAccount]);

    function handlePageChange(page) {
        setActivePage(page);
    }

    function handlePerRowsChange(newPerPage, page) {
        setActivePage(page);
        setPerPage(newPerPage)
    }

    const columns = [
        { name: "Sl. No", center: "true", width: '60px', selector: (row) => row?._id, cell: (row, index) => (activePage - 1) * perPage + (index + 1) },
        {
            name: "Ad Set Name", center: "true", selector: (row) => row?.channel_name, grow: 1.4, cell: (row) => (
                <>{row?.adSetName}</>
            )
        }, {
            name: "Ads Account", center: "true", selector: (row) => row?.category, grow: 1.4, cell: (row) => (
                <p className="mb-0">{row?.account_name ?? "--"}</p>
            )
        }, {
            name: "Status", center: "true", selector: (row) => row?.adSetStatus, cell: (row) => (
                <p className={`mb-0 ${row?.adSetStatus == "ACTIVE" ? 'bg-[#15BC0020]' : row?.adSetStatus == "PAUSED" ? 'bg-[#FABC0520]' : row?.adSetStatus == "INACTIVE" ? 'bg-[#ED1C2420]' : 'bg-[#00000020]'} ${row?.adSetStatus == "ACTIVE" ? 'text-[#15BC00]' : row?.adSetStatus == "PAUSED" ? 'text-[#FABC05]' : row?.adSetStatus == "INACTIVE" ? 'text-[#ED1C24]' : 'text-[#000000]'} px-3 py-1 rounded-full font-medium`}>{
                    row?.adSetStatus
                }</p>
            )
        }, {
            name: "Budget/Day", center: "true", selector: (row) => row?.daily_budget, grow: 1.4, cell: (row) => (
                "₹" + (row?.budget ?? 0)
            )
        }, {
            name: "Spends", center: "true", selector: (row) => row?.spend, grow: 1.4, cell: (row) => (
                "₹" + row?.spend ?? "0"
            )
        }, {
            name: <div><p>Clicks</p><p className='text-[10px]'>Meta | Attriva</p></div>, center: "true", selector: (row) => row?.amount, grow: 1.4, cell: (row) => (
                <p>{row?.clicks || "0"} | {row?.advyClicks || "0"}</p>
            )
        }, {
            name: "Registration", center: "true", selector: (row) => row?.amount, grow: 1.4, cell: (row) => (
                row?.registrations || "--"
            )
        }, {
            name: "Reach", center: "true", selector: (row) => row?.reach, grow: 1.4, cell: (row) => (
                row?.reach ?? "--"
            )
        }, {
            name: "Impression", center: "true", selector: (row) => row?.impressions, grow: 1.4, cell: (row) => (
                row?.impressions ?? "--"
            )
        }, {
            name: "Installs", center: "true", selector: (row) => row?.impressions, grow: 1.4, cell: (row) => (
                row?.installs ?? "--"
            )
        }, {
            name: "Events", center: "true", selector: (row) => row?.amount, grow: 1.4, cell: (row) => (
                "N/A"
            )
        }
    ];

    const conditionalRowStyles = [
        {
            when: row => row.toggleSelected,
            style: {
                backgroundColor: "var(--green-30) !important",
                userSelect: "none"
            }
        }, {
            when: row => row?._id,
            style: {
                cursor: "pointer"
            }
        }
    ];

    const handleRowClicked = row => {
        const updatedData = tableData.data.map(item => {
            if (row?._id === item?._id) {
                const isSelected = !item.toggleSelected;
                if (isSelected) { setSelectedTab(3) }
                setSelectedAdSet(isSelected ? row : null);
                return {
                    ...item,
                    toggleSelected: isSelected,
                };
            }
            return {
                ...item,
                toggleSelected: false,
            };
        });

        setTableData({
            ...tableData,
            data: updatedData,
        });
    };

    return (
        <>
            <TableComponent
                columns={columns}
                data={tableData.data}
                isHeader={true}
                totalRows={tableData.totalCount}
                isPagination={false}
                paginationPerPage={perPage}
                handlePageChange={(e) => handlePageChange(e)}
                handlePerRowsChange={(newPerPage, page) => handlePerRowsChange(newPerPage, page)}
                onRowClicked={(row) => handleRowClicked(row)}
                conditionalRowStyles={conditionalRowStyles}
            />

            <Pagination itemsPerPage={perPage} totalCount={tableData.totalCount} pageChangeFunction={(pageNum) => handlePageChange(pageNum)} currentPage={activePage} />
        </>
    )
}

export default AdSetTab